module.exports = __webpack_public_path__ + "img/france-flag-icon.aedf40b0.svg";